'use client';

import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

const FrequentQuestions = (): JSX.Element => {
  const t = useTranslations();

  return (
    <section>
      <LayoutGrid className="pt-20">
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <TypographyV3
            Element="h6"
            variant="unset"
            className="mb-14 text-center text-[26px] leading-[31px] md:text-[40px] md:leading-[48px]"
          >
            {t('extend_section_header_13')}
          </TypographyV3>
        </GridItem>
      </LayoutGrid>
      <LayoutGrid className="pb-20">
        <GridItem
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 'main' }}
          className="flex flex-col gap-10 lg:flex-row lg:gap-16"
        >
          <div className="flex flex-1 flex-col">
            <TypographyV3 className="pb-3.5 text-2xl">
              {t('extend_section_header_14')}
            </TypographyV3>
            <TypographyV3>{t('extend_section_header_15')}</TypographyV3>
          </div>
          <div className="flex flex-1 flex-col">
            <TypographyV3 className="pb-3.5 text-2xl">
              {t('extend_section_header_16')}
            </TypographyV3>
            <TypographyV3>{t('extend_section_header_17')}</TypographyV3>
          </div>
          <div className="flex flex-1 flex-col">
            <TypographyV3 className="pb-3.5 text-2xl">
              {t('extend_section_header_18')}
            </TypographyV3>
            <TypographyV3>{t('extend_section_header_19')}</TypographyV3>
          </div>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default FrequentQuestions;
